var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "sector-submit-bar-wrapper flex justify-flex-end align-center"
    },
    [
      _c("div", { staticClass: "questions-info" }, [
        _vm._v(
          "Questions: " +
            _vm._s(_vm.answeredQuestions) +
            "/" +
            _vm._s(_vm.totalQuestions)
        )
      ]),
      _c(
        "div",
        { staticClass: "submit-button" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "sector",
                disabled: _vm.answeredQuestions < _vm.totalQuestions
              },
              on: { click: _vm.changeSector }
            },
            [
              _vm.nextSector != null
                ? _c("span", [_vm._v("Next: " + _vm._s(_vm.nextSector.name))])
                : _c("span", [_vm._v("Finish")]),
              _c("i", { staticClass: "el-icon-arrow-right el-icon-right" })
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }